import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import {GMap, Button, Icon} from 'components';

import styles from './Map.module.scss';
import Context from '../../context';
import {VIEW_PHYSICAL} from '../../constants';

const options = {};

export const Map = ({gKey}) => {
  const {dataTable, viewmode} = useContext(Context);

  const markers = dataTable.map(item => ({
    id: item.groupId,
    position: item.latLng,
    tooltip: (
      <div className={styles.tooltipContent}>
        <a
          className={styles.groupName}
          target="_blank"
          rel="noopener noreferrer"
          href={item.link || '#'}
        >
          {item.groupName}
          <Icon type="arrowRightGrey" className={styles.linkIcon} />
        </a>
        <div className={styles.location}>{item.physical}</div>
        {item.user.name && (
          <div>
            <span>Group leader: </span>
            {item.user.link ? (
              <Button
                target="_blank"
                rel="noopener noreferrer"
                href={
                  item.user.link.match(/.+?@.+/)
                    ? 'mailto:' + item.user.link
                    : item.user.link
                }
                type="link"
              >
                {item.user.name}
              </Button>
            ) : (
              item.user.name
            )}
          </div>
        )}
      </div>
    ),
    analyticsEvent: {
      event: 'tooltip',
      tooltipField: 'map',
      tooltipValue: item.groupId,
    },
  }));

  const divStyle = {
    display: viewmode === VIEW_PHYSICAL ? 'block' : 'none',
  };

  return (
    <div className={styles.wrap} style={divStyle}>
      <GMap options={options} markers={markers} gKey={gKey} />
    </div>
  );
};

Map.propTypes = {
  gKey: PropTypes.string,
};

Map.defaultProps = {
  gKey: '',
};
